/**
 * @author Mustafa Omran <promustafaomran@hotmail.com>
 */
import * as $ from 'jquery';
import { Observable } from 'rxjs/Rx';
import { from } from 'rxjs/observable/from';
import { NgProgress } from 'ngx-progressbar';
import { Router, ActivatedRoute } from '@angular/router';
import { CartService } from "../../../services/cart/cart.service";
import { environment } from './../../../../../environments/environment';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Component, OnInit, Input, EventEmitter } from '@angular/core';
import { AccountService } from './../../../services/customers/account.service';
import { MegaMenuService } from './../../../services/Home/mega-menu.service';

@Component({
  selector: 'martmax-sticky',
  styleUrls: ['./sticky.component.css'],
  templateUrl: './sticky.component.html',
  providers: [
    AccountService,
    MegaMenuService,
  ]
})

export class StickyComponent implements OnInit {

  public url;
  public result;
  public errors: any;
  public customer: any;
  public innerWidth: any;
  public totalProducts: number;
  public searchForm: FormGroup;
  public mobileSearchForm: FormGroup;

  public categories;

  constructor(
    private router: Router,
    private fb: FormBuilder,
    public progress: NgProgress,
    public route: ActivatedRoute,
    public cartService: CartService,
    public accountService: AccountService,
    public megaMenuService: MegaMenuService,
  ) {
  }

  public ngOnInit() {

    this.jQuery();
    this.createForm();
    this.getCategories();
    this.createMobileForm();
    this.getCustomerDetials();
    this.totalProducts = this.cartService.cartTotalItem();

  }

  public createForm() {
    this.searchForm = this.fb.group({
      keywords: ['', [Validators.required]]
    });
  }

  public createMobileForm() {
    this.mobileSearchForm = this.fb.group({
      keywords: ['', [Validators.required]]
    });
  }


  /**
   * submit keywords
   */
  public submitKeywords() {
    this.progress.start();
    let url = this.validateURL(this.searchForm.value.keywords);

    if (url != true) {
      this.router.navigate(['search/', this.searchForm.value.keywords]);
    } else {
      window['buyForMeUrl'] = this.searchForm.value.keywords;
      this.router.navigate(['products/buyforme']);
    }

    this.progress.done();
  }

  /**
   * validate url 
   * 
   * @param url 
   */
  public validateURL(url: string) {
    let pattern = /(ftp|http|https):\/\/(\w+:{0,1}\w*@)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-\/]))?/;
    if (pattern.test(url)) {
      return true;
    }
  }

  /**
   * get categories 
   */
  private getCategories() {
    this.megaMenuService.getMegaMenu().subscribe(
      (data) => {
        if (data) {
          this.categories = data.megaMenu;
          this.categoryAccordion();
        }
      }, (errors) => {
        this.errors = errors;
      });
  }

  private categoryAccordion() {
    setTimeout(() => {
      $('.accordion-toggle-btn').on('click', function () {
        let btn = $(this),
          dropdown = btn.closest('li').find(' >  .dropdown-sub-menu');

        btn.toggleClass('fa-plus fa-minus');

        dropdown.slideToggle();

      });
    }, 2000);
  }

  /**
   * display categories
   */
  public displayCategories() {
    return this.categories;
  }
  /**
   * log the customer out !
   */
  public logout() {
    localStorage.removeItem('currentCustomer');
  }

  /**
   * get customer details 
   */
  public getCustomerDetials() {
    if (!localStorage.getItem('currentCustomer')) {
      return;
    }
    this.customer = JSON.parse(localStorage.getItem('currentCustomer'));
    let params: any = {
      customer_access_token: this.customer.c_a_t,
    };
    this.accountService.show(params).subscribe(
      (data) => {
        if (data) {
          this.customer = data.customer;
        }
      },
      (error) => {
        this.errors = error;
      }
    );
  }

  public jQuery() {

    $(".side-menu").hide();
    $(".menu-button").click(function () {
      $(".side-menu").toggle(300, function () {
        $(".sticky-header .navbar").toggleClass("show-nav")
      })
    });

    $(".side-menu-sub .dropdown.top-level").click(function () {
      $(this).children("ul").toggleClass("hide");
    });

    $(".side-menu-sub .dropdown.top-level .dropdown-sub-menu .dropdown").click(function () {
      $(this).children(".dropdown-sub-menu").toggleClass("show");
    });

    $(".hot-search").hide();
    $(".small-dev li .fa-search").click(function () {
      $(".hot-search").show(200);
    });
    $("#searchForm span .fa-angle-left").click(function () {
      $(".hot-search").hide(200);
    });

    $(".mobile-search").hide();
    $(".small-dev .fa-search").click(function () {
      $(".mobile-search").toggle(400);
    });

    let scrollButton = $("#scroll-top");
    $(".close-menu").hide();
    if ($(window).width() < 992) {
      $(".close-menu").show();
    }

    $(window).scroll(function () {
      let scrollPos = $(window).scrollTop(),
        navbar = $('.navbar'),
        topHeader = $('.top-header');

      if (scrollPos > 150) {
        $(".sticky-header nav").addClass(" navbar-fixed-top");
        $('.sticky-header .navbar>.container .navbar-brand img').attr('src', './assets/images/martmax-small-logo.png');
      }
      else {
        $(".sticky-header nav").removeClass(" navbar-fixed-top");
        $('.sticky-header .navbar>.container .navbar-brand img').attr('src', './assets/images/martmax-logo.png');
      }

      if ($(window).width() < 768) {
        $(".static-menu").hide();
      }
      else {
        let brandsContainer = $('.brand-container');

        if (scrollPos >= 560) {
          $(".static-menu").fadeIn();
        }
        else {
          $(".static-menu").fadeOut();
        }
      }
    });
  }

}


// WEBPACK FOOTER //
// /opt/build/repo/src/app/MartMax/components/home-page/sticky/sticky.component.ts